import { Box } from '@mui/material';
import React from 'react';

import amExIcon from '../images/american_express_icon.png';
import discoverIcon from '../images/discover_icon.png';
import mastercardIcon from '../images/mastercard_icon.png';
import visaIcon from '../images/visa_icon.png';

const getCreditCardImage = (brand: string) => {
  switch (brand) {
    case 'amex':
      return amExIcon;
    case 'discover':
      return discoverIcon;
    case 'mastercard':
      return mastercardIcon;
    case 'visa':
      return visaIcon;
    default:
      return '';
  }
};

export const CreditCardIcon = (brand: string) => {
  if (brand)
    return (
      <Box
        component="img"
        src={getCreditCardImage(brand)}
        sx={{ height: '1em' }}
      />
    );
  return null;
};
